var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.8125C17.8652 1.8125 21.0925 3.14931 23.472 5.52885C25.8516 7.90839 27.1884 11.1357 27.1884 14.5009C27.1884 17.8661 25.8516 21.0934 23.472 23.473C21.0925 25.8525 17.8652 27.1893 14.5 27.1893C11.1348 27.1893 7.90747 25.8525 5.52793 23.473C3.14839 21.0934 1.81158 17.8661 1.81158 14.5009C1.81158 11.1357 3.14839 7.90839 5.52793 5.52885C7.90747 3.14931 11.1348 1.8125 14.5 1.8125ZM16.4031 9.60262C17.3456 9.60262 18.1105 8.94831 18.1105 7.97862C18.1105 7.00894 17.3438 6.35462 16.4031 6.35462C15.4606 6.35462 14.6994 7.00894 14.6994 7.97862C14.6994 8.94831 15.4606 9.60262 16.4031 9.60262ZM16.7348 19.8016C16.7348 19.6076 16.8019 19.1037 16.7638 18.8174L15.2739 20.532C14.9658 20.8564 14.5797 21.0812 14.3985 21.0214C14.3163 20.9911 14.2475 20.9325 14.2047 20.8561C14.1618 20.7797 14.1476 20.6904 14.1647 20.6045L16.6478 12.76C16.8508 11.7649 16.2926 10.8569 15.109 10.7409C13.8602 10.7409 12.0223 12.0078 10.904 13.6155C10.904 13.8076 10.8677 14.2861 10.9058 14.5725L12.3939 12.8561C12.702 12.5352 13.0609 12.3087 13.2421 12.3703C13.3314 12.4024 13.4046 12.4681 13.4459 12.5535C13.4873 12.6389 13.4935 12.7371 13.4632 12.8271L11.0019 20.6335C10.7173 21.547 11.2556 22.4424 12.5606 22.6454C14.4819 22.6454 15.6165 21.4092 16.7366 19.8016H16.7348Z",
    fill: "url(#paint0_linear_170_11468)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_11468",
    x1: 14.5,
    y1: 1.8125,
    x2: 14.5,
    y2: 27.1893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AEABF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e7e4bada89734559aebdeeeaf6b6bab6.svg";
export { ForwardRef as ReactComponent };